import React from "react";
import PropTypes from "prop-types";
import { NativeSelect } from "@mui/material";
import MotionChevronDown from "../../Icons/MotionChevronDown.js";

const EMPSelectField = React.forwardRef((props, ref) => {
  const {
    testId,
    name,
    menuItems,
    value,
    disabled,
    onChange,
    defaultValue,
    className,
    inputProps,
    sx,
  } = props;

  const valueProps = value !== undefined ? { value } : { defaultValue };

  return (
    <NativeSelect
      {...valueProps}
      disableUnderline
      IconComponent={MotionChevronDown}
      data-testid={testId}
      name={name}
      disabled={disabled}
      onChange={onChange}
      ref={ref}
      variant="standard"
      className={className}
      inputProps={inputProps}
      sx={{
        boxSizing: "border-box",
        width: "100%",
        margin: 0,
        padding: 0,
        fontFamily: "inherit",
        // The theme outlines the input but doesn't pad it, so pad the text and
        // keep it clear of the chevron
        "& .MuiNativeSelect-select.MuiNativeSelect-select": {
          py: 2,
          pl: 4,
          pr: 12,
        },
        "& .MuiNativeSelect-icon": { right: 12 },
        ...sx,
      }}
    >
      {menuItems.map((item, idx) => (
        <option
          data-testid={item.id}
          value={item.value}
          key={item.value || idx}
          disabled={item.disabled}
        >
          {item.text}
        </option>
      ))}
    </NativeSelect>
  );
});

EMPSelectField.propTypes = {
  testId: PropTypes.string,
  name: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
      text: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
  sx: PropTypes.object,
};

EMPSelectField.defaultProps = {
  testId: undefined,
  name: undefined,
  menuItems: [],
  value: undefined,
  disabled: false,
  onChange: undefined,
  defaultValue: undefined,
  className: undefined,
  inputProps: undefined,
  sx: {},
};

EMPSelectField.displayName = "EMPSelectField";

export default EMPSelectField;
